import React, { useState, useEffect, useContext, Component } from 'react';
import { useNavigate, Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';


const FailPage = () => {

  return (
    <>
      <Header />

      <main className="page">

        <div
          className="bg-light w-100 p-4 d-flex align-items-center"
          style={{ height: "70vh" }}
        >
          <div className="user-form   mx-auto" style={{ maxWidth: 700 }}>
            <div className="card  border bg-white shadow  m-0 rounded-sm-0 overflow-hidden">
              <div className="body px-4 text-center">
                <i className="ri-error-warning-fill text-danger" style={{ fontSize: 100 }}></i>
                <h4 className="text-danger"> Payment Failure !!</h4>
                <div className="d-flex gap-4 pb-3">
                  <Link
                    to="/"
                    className="btn btn-dark fw-light w-100 d-flex"
                    type="button"
                  >
                    <i className="ri-arrow-left-s-line ms-auto btn-sm" />
                    <span className="col"> Go Home </span>
                  </Link>
                  <Link
                    to="/all-transactions"
                    className="btn btn-primary fw-light w-100 d-flex"
                    type="button"
                  >
                    <span className="col"> View </span>
                    <i className="ri-arrow-right-s-line ms-auto" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

      </main>


      <Footer />
    </>

  );
};

export default FailPage